import { createFileRoute } from "@tanstack/react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { CockpitPageShell } from "@/components/cockpit/CockpitPageShell";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { CockpitSkeletonRows } from "@/components/cockpit/CockpitSkeleton";
import { CockpitErrorNotice } from "@/components/cockpit/CockpitErrorNotice";
import { SocialDashboardSetup } from "@/components/social/SocialDashboardSetup";
import { SocialDashboardView } from "@/components/social/SocialDashboardView";
import { getMySocialDashboard } from "@/lib/social-dashboard.functions";

export const Route = createFileRoute("/_cockpit/cockpit/social-media")({
  head: () => ({
    meta: [
      { title: "Social Media – Cockpit – creategy" },
      { name: "description", content: "Entwicklung Ihrer Social-Media-Kanäle im Vergleich zum Ausgangswert." },
      { property: "og:title", content: "Social Media – Cockpit – creategy" },
      { property: "og:description", content: "Startwerte und Entwicklung Ihrer Social-Media-Kanäle im creategy Cockpit." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CockpitSocialMediaPage,
});

const MY_SOCIAL_DASHBOARD_KEY = ["cockpit", "social-dashboard"];

function CockpitSocialMediaPage() {
  const qc = useQueryClient();
  const getFn = useServerFn(getMySocialDashboard);
  const q = useQuery({ queryKey: MY_SOCIAL_DASHBOARD_KEY, queryFn: () => getFn() });

  return (
    <CockpitPageShell>
      <CockpitPageHeader
        title="Social Media"
        description="Wie sich Ihre Kanäle seit Projektstart entwickeln. Sie können jederzeit eigene Messungen eintragen."
      />
      {q.isLoading ? (
        <CockpitSkeletonRows />
      ) : q.error ? (
        <CockpitErrorNotice error={q.error} />
      ) : !q.data ? (
        <p className="mt-6 font-body text-sm text-muted-foreground">
          Das Social-Media-Dashboard ist für Ihr Konto noch nicht freigeschaltet.
        </p>
      ) : (
        <>
        <SocialDashboardSetup data={q.data} onChanged={() => qc.invalidateQueries({ queryKey: MY_SOCIAL_DASHBOARD_KEY })} />
        <SocialDashboardView
          data={q.data}
          onChanged={() => qc.invalidateQueries({ queryKey: MY_SOCIAL_DASHBOARD_KEY })}
          fileLabel="dashboard"
        />
        </>
      )}
    </CockpitPageShell>
  );
}
